import { useRef } from 'react';
import type { VoidFunctionComponent } from 'react';

import { useOnClickOutside } from '../../../../hooks';
import { trimString } from '../../../../utils';

import type { Suggestion } from './types';

import styles from './ItemizedRuleSuggestionList.module.less';

type Props = {
  suggestions: Array<Omit<Suggestion, 'link'>>;
  selectRule: (id: string | null) => void;
  onExternalClick: () => void;
};

const ItemizedRuleSuggestionList: VoidFunctionComponent<Props> = ({
  suggestions,
  selectRule,
  onExternalClick,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside({
    ref,
    handler: onExternalClick,
    shouldSkipClickOutside: suggestions.length === 0,
  });

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <div ref={ref} className={styles.suggestions}>
      {suggestions.map(({ description, id, title }) => (
        <button
          type="button"
          key={id}
          className={styles.suggestionItem}
          onClick={(e) => {
            e.stopPropagation();
            selectRule(id);
          }}
        >
          <span>{title ? `${id}: ${title}` : id}</span>
          {description && <p>{trimString(description, 170)}</p>}
        </button>
      ))}
    </div>
  );
};

export default ItemizedRuleSuggestionList;
